import React from 'react';
import {
  NextPage,
  GetStaticPaths,
  GetStaticProps,
} from 'next';
import Head from 'next/head';
import {
  getI18nStaticPaths,
  withI18n,
  getI18nProps,
  GetI18nProps,
  GetI18nQuery,
  useI18n,
} from '../../utils/i18n';

import SellPage, { AllTranslationsNeeded as SellPageTranslations } from '../../components/SellPage';

const TranslationsNeeded = 'pagesTranslations/[language]/sell';

const Page: NextPage = () => {
  const { translations } = useI18n(TranslationsNeeded);
  return (
    <>
      <Head>
        <meta name="title" content={translations.title as string} key="title" />
        <title>{translations.title}</title>
        <meta name="description" content={translations.description as string} key="description" />
      </Head>
      <SellPage />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [
    ...getI18nStaticPaths(),
  ],
  fallback: false,
});

export const getStaticProps: GetStaticProps<GetI18nProps, GetI18nQuery> = async ({
  params,
}) => ({
  props: {
    ...await getI18nProps({
      language: params?.language as string,
      paths: [
        TranslationsNeeded,
        ...SellPageTranslations,
      ],
    }),
  },
});

export default withI18n(Page, '/sell');
